import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useThemeStore = defineStore('theme', () => {
  const isDarkMode = ref(localStorage.getItem('darkMode') === 'true')

  function toggleDarkMode() {
    isDarkMode.value = !isDarkMode.value
    localStorage.setItem('darkMode', isDarkMode.value.toString())
    updateTheme()
  }

  function updateTheme() {
    if (isDarkMode.value) {
      document.documentElement.classList.add('dark')
      document.documentElement.style.colorScheme = 'dark'
    } else {
      document.documentElement.classList.remove('dark')
      document.documentElement.style.colorScheme = 'light'
    }
  }

  function initTheme() {
    const savedTheme = localStorage.getItem('darkMode')
    if (savedTheme !== null) {
      isDarkMode.value = savedTheme === 'true'
    } else {
      // Standardmäßig helles Theme verwenden
      isDarkMode.value = false
      localStorage.setItem('darkMode', 'false')
    }
    updateTheme()
  }

  // Initialize theme
  initTheme()

  return {
    isDarkMode,
    toggleDarkMode,
    initTheme
  }
})